import { render } from "./_form.vue?vue&type=template&id=823e6ee0"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customers/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "823e6ee0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('823e6ee0', __exports__)) {
    console.log('reload')
    api.reload('823e6ee0', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=823e6ee0", () => {
    console.log('re-render')
    api.rerender('823e6ee0', render)
  })

}


export default __exports__